import logoPreto from '../../assets/icons/logo_preto.svg';
import logoStrong from '../../assets/icons/logo-strong.svg';
import facebook from '../../assets/icons/facebook-square.svg';
import instagram from '../../assets/icons/instagram.svg';
import linkedin from '../../assets/icons/linkedin.svg';
import './UniFooter.scss';
import { useUserStore } from '../../store/user';
import { useTranslation } from 'react-i18next';

const UniFooter = () => {
    const { darkMode, lng } = useUserStore();
    const { i18n, t } = useTranslation();
    return (
        <footer className='d-flex footer align-items-center justify-content-lg-between'>
            <div>
                <img src={darkMode ? logoStrong : logoPreto} width={96} alt='logo Unipar'/>
                {/* <p className='p-questions'>
                    {
                        lng === 'pt' ? (
                            <>
                                <b>Fale conosco</b><br/>
                                Telefone: +55 (11) 3704-4200<br />
                                PVC - <a href='mailto:atendimentopvc@unipar.com'>atendimentopvc@unipar.com</a> <br/>
                                Químicos - <a href='mailto:servicoaocliente@unipar.com'>servicoaocliente@unipar.com</a>
                            </>
                        ) :
                        lng === 'en' ? (
                            <>
                                <b>Contact us</b><br/>
                                Telephone: +55 (11) 3704-4200<br />
                                PVC - <a href='mailto:atendimentopvc@unipar.com'>atendimentopvc@unipar.com</a> <br/>
                                Químicos - <a href='mailto:servicoaocliente@unipar.com'>servicoaocliente@unipar.com</a> 
                            </>
                        ) :
                        (
                            <>
                                <b>Hable con nosotros</b> <br/> 
                                Teléfono: +54 (11) 5283-9300<br/>
                                Argentina - <a href='mailto:atencionalcliente@unipar.com'>atencionalcliente@unipar.com</a> 
                            </>
                        )
                    }                    
                </p> */}
            </div>
            <div>
                <div className='icons d-flex justify-content-end'>
                    <a href='https://www.instagram.com/grupounipar/' target='_blank'><img src={instagram} width={25} alt='logo instagram'/></a>
                    <a href='https://www.facebook.com/grupounipar' target='_blank'><img src={facebook} width={25} alt='logo facebook'/></a>
                    <a href='https://www.linkedin.com/company/grupo-unipar/' target='_blank'><img src={linkedin} width={25} alt='logo linkedin'/></a>
                </div>
                <span><a href='https://unipar.com/politica-de-privacidade/' target='_blank'>{t('policies')}</a> | Copyright © 2023 UNIPAR</span>
            </div>
        </footer>
    )
}

export default UniFooter;